import Layout2 from '@/layout/Layout2'
let ja = require('../../common/lang/ja')
let zh = require('../../common/lang/zh-CN')

export default [{
  path: '/shop',
  component: Layout2,
  children: [{
    path: '',
    name: 'shop',
    component: () => import('@/merchanAdmin/shopdetail/shopDetail'),
    meta: {
      zhtitle: zh.m.aside.nav.SHOPS,
      jatitle: ja.m.aside.nav.SHOPS,
      pername: "shop_setting"
    },
    
  }, {
    path: '/shop',
    name: 'shop',
    component: () => import('@/merchanAdmin/shopdetail/shopDetail'),
    meta: {
      zhtitle: zh.m.aside.nav.SHOPS,
      jatitle: ja.m.aside.nav.SHOPS,
      pername: "shop_setting"
    },

  }
  ]
}]
